import React, { Component } from "react";
import { connect } from "react-redux";
import LoadingList from "./_LoadingList";
import Manifest from "./_Manifest";


class Reports extends Component {
  render() {
    const { addOrEdit, formName } = this.props.ui;

    return (
      <div>
        {this.props.shipment.id && (
          <div>
            <LoadingList
              visible={
                this.props.ui.reportName == "loadingList" 
              }
            />
            <Manifest
              visible={
                this.props.ui.reportName == "manifest"  
              }
            />
          </div>
        )}
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    ui: state.ui,
    shipment: state.selected.shipment
  };
};

export default connect(mapStateToProps)(Reports);



// WEBPACK FOOTER //
// ./src/views/Reports/index.js